export type LevelCounts = { info: number; warn: number; error: number }

/**
 * Quanto apagar nesta passada. Teto por passada: o Loki roda na thread da UI e apagar
 * dezenas de milhares de uma vez congela a tela (~3 s para 45 mil no desktop). `backlog`
 * = ainda vai sobrar acima de `max` depois desta passada (a próxima escrita não sorteia).
 */
export function trimBudget(
  count: number,
  max: number,
  target: number,
  perPass: number,
): { toDelete: number; backlog: boolean } {
  if (count <= max) return { toDelete: 0, backlog: false }
  const toDelete = Math.min(count - target, perPass)
  return { toDelete, backlog: count - toDelete > max }
}

/**
 * Quantos eventos descartar de cada nível para remover `toDelete` no total,
 * sacrificando primeiro `info`, depois `warn` e por último `error`.
 */
export function planTrim(toDelete: number, counts: LevelCounts): LevelCounts {
  let left = Math.max(0, toDelete)
  const plan: LevelCounts = { info: 0, warn: 0, error: 0 }
  for (const level of ['info', 'warn', 'error'] as const) {
    const take = Math.min(left, counts[level])
    plan[level] = take
    left -= take
  }
  return plan
}
